webpackJsonp([142629428675168],{

/***/ 415:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"excerpt":"Foreword : I am currently sitting on our first bus transfer of the trip. Yes, the driver is a mad man, hell bent on choosing his own speed limits and overtaking any inferior driver he encounters. How each victim was given a license to drive, with…","id":"/opt/build/repo/src/pages/blog-posts/rio-via-lisbon/rio-via-lisbon.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Setting off: Rio de Janeiro via Lisbon","date":"April 20, 2018","path":"/rio-via-lison","tags":["travel","flights"],"thumbnail":{"childImageSharp":{"resize":{"src":"/static/lisboa-sign-c645ac8bbf5610020f25147f7e6ad224-4c3ea.jpg"}}}}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-bc1b934a77ea3938caad.js